/**
 * Store locator: Leaflet map + Nominatim geocoding.
 * One request per second to Nominatim (usage policy).
 */
(function () {
  const NOMINATIM_DELAY_MS = 1100;
  /* Center: midden Nederland; zoom 8 ≈ breedte Den Haag–Arnhem */
  const NETHERLANDS_CENTER = [52.03, 5.12];
  const NETHERLANDS_ZOOM = 8;

  function geocode(address) {
    const url = 'https://nominatim.openstreetmap.org/search?' + new URLSearchParams({
      q: address,
      format: 'json',
      limit: 1
    });
    return fetch(url, {
      headers: { 'Accept': 'application/json', 'Accept-Language': 'nl' }
    }).then(function (res) { return res.json(); });
  }

  function initSection(config) {
    const sectionId = config.sectionId;
    const mapEl = document.getElementById('StoreLocatorMap-' + sectionId);
    const container = mapEl && mapEl.closest('[data-section-id]');
    if (!mapEl || !container) return;

    const detailTitle = container.querySelector('[data-detail-title]');
    const detailImage = container.querySelector('[data-detail-image]');
    const detailAddress = container.querySelector('[data-detail-address]');
    const detailBody = container.querySelector('[data-detail-body]');
    const detailContent = container.querySelector('[data-detail-content]');
    const locations = config.locations || [];
    const markerIconUrl = config.markerIconUrl || '';
    const locationParam = new URLSearchParams(window.location.search).get('location');
    const initialLocationId = locationParam ? parseInt(locationParam, 10) : null;
    const initialLoc = initialLocationId && locations.length ? locations.find(function (loc) { return loc.id === initialLocationId; }) : null;

    /* Always show the map (also when no locations yet) */
    const map = L.map(mapEl, { scrollWheelZoom: true }).setView(NETHERLANDS_CENTER, NETHERLANDS_ZOOM);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    /* Favicon as marker: center anchor so icon sits on the point */
    const iconOpts = markerIconUrl
      ? {
          iconUrl: markerIconUrl,
          iconSize: [48, 48],
          iconAnchor: [24, 24],
          popupAnchor: [0, -24]
        }
      : null;
    const markerIcon = iconOpts ? L.icon(iconOpts) : undefined;

    function showDetail(loc) {
      if (detailTitle) detailTitle.textContent = loc.title;
      if (detailAddress) detailAddress.textContent = loc.address || '';
      if (detailBody) detailBody.innerHTML = loc.content || '';
      if (detailImage) {
        detailImage.innerHTML = '';
        if (loc.image) {
          const img = document.createElement('img');
          img.src = loc.image;
          img.alt = loc.title || '';
          img.loading = 'lazy';
          detailImage.appendChild(img);
        }
      }
      if (detailContent) detailContent.classList.remove('hidden');
    }
    if (initialLoc) showDetail(initialLoc);

    let index = 0;
    function addNextMarker() {
      if (index >= locations.length) return;
      const loc = locations[index];
      index += 1;
      geocode(loc.address).then(function (results) {
        if (results && results[0]) {
          const lat = parseFloat(results[0].lat);
          const lon = parseFloat(results[0].lon);
          const marker = L.marker([lat, lon], markerIcon ? { icon: markerIcon } : {}).addTo(map);
          marker._locationData = loc;
          marker.on('click', function () {
            showDetail(loc);
          });
          if (initialLocationId && loc.id === initialLocationId) {
            map.setView([lat, lon], 16);
          }
        }
        setTimeout(addNextMarker, NOMINATIM_DELAY_MS);
      }).catch(function () {
        setTimeout(addNextMarker, NOMINATIM_DELAY_MS);
      });
    }

    addNextMarker();
  }

  function run() {
    if (typeof L === 'undefined') {
      setTimeout(run, 50);
      return;
    }
    document.querySelectorAll('script[data-store-locator-data]').forEach(function (script) {
      try {
        var config = JSON.parse(script.textContent);
        initSection(config);
      } catch (e) {
        console.warn('Store locator: invalid JSON', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
